module.exports = __webpack_public_path__ + "static/fonts/Robotobold.1fc6a83.ttf";